import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Doughnut} from 'react-chartjs'
import config from '../../config'
import {
  Link
} from '../../components'

import Styles from './PlanScorecardDefaultAllocation.css'


@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardDefaultAllocation extends Component {
  static propTypes = {
    allocationStats: PropTypes.object.isRequired,
    planData: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      allocationStats: props.allocationStats,
      planData: props.planData
    }
  }

  render() {
    const { allocationStats, planData } = this.state

    //
    return (
      <div styleName='chart-headline'>
        {
          allocationStats.default.percStr === 'NaN%' ?
            null :
            (
              <Doughnut
                data={[
                  { value: allocationStats.default.perc,
                    // label: 'Default',
                    color: '#313131' },
                  { value: allocationStats.default.percOther,
                    // label: 'Other',
                    color: '#D5D5D5' }
                ]}
                options={config.chartOptions}
                width='150'
                height='150'
              />
            )
        }
        <div>
          {
            allocationStats.default.percStr === 'NaN%' ?
              null :
              (
                <div styleName='chart-headline-text'>
                  <h2>
                    {allocationStats.default.percStr} of plan assets are
                    invested in the target date option.
                  </h2>
                  <p>
                    <b>Target date option:</b> {planData.default_fund_name}
                  </p>
                </div>
              )
          }
          <div styleName='chart-sublede'>
            Most employer-offered retirement plans have what's called a <Link
             to={config.routes.methodology + '#targetdates'}
             title={'Target date funds'}
             xstrong
            >target date option</Link>, broadly diversified investments that
            offer different "target dates" for investors in different age
            brackets. These target date funds mostly invest in index funds
            that are not sustainably invested. If a retirement plan has
            automatic enrollment, the target date series is usually the
            default investment option, also known as the <Link
             to={config.routes.methodology + '#qdia'}
             title={'Qualified Default Investment Alternative'}
             xstrong
            >Qualified Default Investment Alternative</Link>. When you sign
            up for the plan, your savings are put in a default investment,
            and most plan participants never switch.
            Even if plans don't have automatic enrollment, a target date
            series frequently serves as the de facto default, capturing more
            assets than any other plan options.
            For the overall plan scorecard above, we use the <Link
             to={config.routes.methodology + '#why2050'}
             title={'Why the 2050 fund?'}
             xstrong
            >2050 target date</Link> as the representative of the fund series.
          </div>
        </div>
      </div>
    )
  }
}